import React, {useState} from "react";
//Components
import Match from "./matchBox";
// material-ui
import {
  Table,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Typography
} from "@material-ui/core/";
import {makeStyles} from "@material-ui/core/styles";
import {DelColButton} from "../styles/styled_predict_table";
import DeleteSweepIcon from "@material-ui/icons/DeleteSweep";
import RestoreFromTrashIcon from "@material-ui/icons/RestoreFromTrash";
import DeleteIcon from "@material-ui/icons/Delete";

const useStyles = makeStyles({
  table: {
    minWidth: 650
  },
  head: {
    fontWeight: 600,
    backgroundImage:
      "linear-gradient(to right, #020d39, #012e58, #134e75, #307190, #5394a9);"
  },
  tableRightBorder: {
    borderWidth: 1,
    borderColor: "e0e0e0",
    borderStyle: "inset"
  },
  head_cell: {
    color: "white",
    fontWeight: "600",
    fontSize: "1em",
    fontFamily: ['Rubik', 'sans-serif'].join(",")

  },
  colTitle: {
    display: "inline-block",
    margin: 0
  },
  row_cell: {
    fontWeight: "400",
    fontSize: "1em"
  }
});

const makeRows = (match_rows) => {
  //create rows from attribute score array returned by fetch in stepper.
  let temp_rows = makeOriginal(match_rows);
  let left_cells = [];
  let right_cells = [];
  let left = Object.entries(temp_rows[0]);
  let right = Object.entries(temp_rows[1]);
  left.map((arr) => {
    let temp = {};
    temp[arr[0]] = arr[1];
    temp["isHidden"] = false;
    left_cells.push(temp);
    temp = {};
  });
  right.map((arr) => {
    let temp = {};
    temp[arr[0]] = arr[1];
    temp["isHidden"] = false;
    right_cells.push(temp);
    temp = {};
  });
  let rows = [];
  rows = [left_cells, right_cells];
  return rows;
};

const makeCols = (columns) => {
  //remove cluster_id and id keys, unnecessary for table and predictFetch.
  columns.map((column, i) => {
    if (column.name === "cluster_id" || column.name === "id") {
      columns.splice(i, 1);
    }
  });
  return columns;
};

//to avoid altering original state of rows, make a copy of the rows and remove the "cluster_id" key.
const makeOriginal = (cluster_rows) => {
  let rows = [cluster_rows.left, cluster_rows.right];
  let rows_cp = rows.map((a) => Object.assign({}, a));
  rows_cp.map((row) => delete row["cluster_id"]);
  return rows_cp;
};

// note:  predictFetch(query_type: predict, input, mod: bool)

export default function AttrTable(props) {
  const classes = useStyles();
  let made_rows = makeRows(props.cluster_pairs);
  let made_columns = makeCols(props.columns);
  const [columns] = useState(made_columns);
  const [rows] = useState(made_rows);
  const made_original = makeOriginal(props.cluster_pairs);
  const [original] = useState(made_original);
  const mod_clus = original.map((a) => Object.assign({}, a));
  const [mod_cluster, setModCluster] = useState(mod_clus);

  const updateCell = (row_idx, col_key) => {
    //=== toggle isHidden of cell and alter mod_cluster (pair copy)
    let selection;
    rows[row_idx].map((cell) => {
      if (cell[col_key]) {
        selection = cell;
      }
    });
    selection["isHidden"]
      ? (selection["isHidden"] = !selection["isHidden"])
      : (selection["isHidden"] = true);

    if (selection["isHidden"]) {
      mod_cluster[row_idx][col_key] = "";
    }
    if (!selection.isHidden) {
      rows[row_idx].map((cell) => {
        if (cell[col_key]) {
          mod_cluster[row_idx][col_key] = cell[col_key];
        }
      });
    }

    setModCluster(mod_cluster);
    props.predictFetch("predict", mod_cluster, true);
  };

  const updateColumns = (i) => {
    // modify a mod_cluster (copy of row pair) based on column delete or re-add and pass to fetch request in stepper.js
    let selection = columns[i];
    //check for isHidden, toggle or add the key to selected cell.
    selection["isHidden"]
      ? (selection["isHidden"] = !selection["isHidden"])
      : (selection["isHidden"] = true);

    if (selection.isHidden) {
      mod_cluster.map((cluster) => {
        cluster[selection.name] = "";
      });
    }
    //re-add the key value pair if unhidden.
    if (!selection.isHidden) {
      rows.map((row, i) => {
        row.map((cell) => {
          if (cell[selection.name] && cell["isHidden"] === false) {
            mod_cluster[i][selection.name] = cell[selection.name];
          }
        });
      });
    }
    setModCluster(mod_cluster);
    props.predictFetch("predict", mod_cluster, true);
  };

  const createCell = (row, column, c_idx, row_idx) => {
    //cell is created on init data and triggered by the state update on un/hide button click cell and column.
    let cellElement;
    row.map((cell) => {
      if (column.isHidden) {
        cellElement = (
          <TableCell
            className={classes.row_cell}
            align="center"
            key={row[column.name] + " " + row_idx.toString()}
          >
            {""}
          </TableCell>
        );
      } else if (
        cell[column.name] === "" &&
        !column.isHidden &&
        !cell.isHidden
      ) {
        cellElement = (
          <TableCell
            className={classes.row_cell}
            align="center"
            key={row[column.name] + " " + row_idx.toString()}
          >
            {""}
          </TableCell>
        );
      } else if (cell[column.name] && !column.isHidden && !cell.isHidden) {
        cellElement = (
          <TableCell
            className={classes.row_cell}
            align="center"
            key={row[column.name] + " " + row_idx.toString()}
          >
            {cell[column.name]}
            <DelColButton
              key={c_idx * row_idx}
              onClick={() => updateCell(row_idx, column.name)}
            >
              <DeleteIcon />
            </DelColButton>
          </TableCell>
        );
      } else if (cell[column.name] && !column.isHidden && cell.isHidden) {
        cellElement = (
          <TableCell
            className={classes.row_cell}
            align="center"
            key={row[column.name] + " " + row_idx.toString()}
          >
            {""}
            <DelColButton
              key={c_idx * row_idx}
              onClick={() => updateCell(row_idx, column.name)}
            >
              <RestoreFromTrashIcon />
            </DelColButton>
          </TableCell>
        );
      }
    });
    return cellElement;
  };

  return (
    <>
      {Object.keys(props.cluster_pairs).length === 0 && (
        <Typography>
          {" "}
          No data was passed from the previous step, please go back and select
          data{" "}
        </Typography>
      )}

      {Object.keys(props.cluster_pairs).length > 0 && (
        <>
          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="cluster table">
              <TableHead className={classes.head}>
                <TableRow>
                  {columns.map((column, i) => (
                    <TableCell
                      key={i}
                      align="center"
                      className={(classes.tableRightBorder, classes.head_cell)}
                    >
                      {column.isHidden ? "" : column.title}
                      <DelColButton onClick={() => updateColumns(i)}>
                        {column.isHidden ? (
                          <RestoreFromTrashIcon
                            style={{paddingTop: 0, fill: "white"}}
                          />
                        ) : (
                          <DeleteSweepIcon
                            style={{paddingTop: 0, fill: "white"}}
                          />
                        )}
                      </DelColButton>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, row_idx) => (
                  <TableRow key={row_idx}>
                    {columns.map((column, c_idx) => (
                      <>{createCell(row, column, c_idx, row_idx)}</>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Match props={props.attr_scores} />
        </>
      )}
    </>
  );
}
